import Common from '../common'
var Js = Common('user')
export default {
	name: 'user',
	mixins: [Js],
	components: {},
	data() {
		return {
			fields: [{
					key: 'id',
					label: 'ID',
					application: [],
					componentName: 'sls-input',
					listType: '',
					width: 50
				},
				{
					key: 'user_no',
					label: '用户NO',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
					header_search: {
						componentName: 'sls-input',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请输入用户NO',
						clearable: true,
						defaultValue: '',
						optionDataName: '',
						changeFunc: function(val, self) {
							if (val) {
								self.searchItem.user_no = val;
							} else {
								delete self.searchItem.user_no;
							};

						},
					},
				},
				{
					key: 'nickname',
					label: '昵称',
					application: ['编辑账号', '添加账号'],
					componentName: 'sls-input',
					listType: 'normal',
					placeholder: '请输入昵称',
					header_search: {
						componentName: 'sls-input',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请输入昵称',
						changeFunc: function(val, self) {
							if (val) {
								self.searchItem.nickname = ['LIKE', ['%' + val + '%']];
							} else {
								delete self.searchItem.nickname;
							};

						},
					}
				},
				/* {
					key: 'role',
					label: '角色',
					application: ['编辑账号', '添加账号'],
					componentName: 'sls-cascader',
					optionsName: 'roleOptions',
					listType: '',
					limit: 10,
					defaultProps: {
						label: 'name',
						value: 'id',
						children: 'children'
					},
				}, */
				/* {
					key: 'behavior',
					label: '会员状态',
					application: ['编辑账号', '添加账号'],
					componentName: 'sls-select',
					optionsName: 'typeOptions',
					listType: 'normal',
					limit: 10,
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					formatter: function(val) {
						if (val.behavior == 0) {
							return '未申请';
						} else if(val.behavior == 1){
							return '审核中';
						}else if(val.behavior == 2){
							return '已通过';
						}
					}
				}, */
				{
					key: 'headImgUrl',
					label: '头像',
					application: [],
					dialogStyle: 'width:100%;',
					customSlot: 'headImgUrl',
					listType: 'normal',
				},
				
				{
					key: "status",
					label: '状态',
					application: [''],
					componentName: 'sls-select',
					optionsName: 'statusOptions',
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					formatter: function(val) {
						if (val.status == 1) {
							return '启用';
						} else {
							return '关闭';
						};
					}
				},
				{
					key: 'create_time',
					label: '创建时间',
					listType: 'normal',
					placeholder: '请选择创建时间',
					header_search: {
						componentName: 'sls-date-time-range',
						style: 'width:160px;margin-right:2px;',
						start_placeholder: '创建开始时间',
						end_placeholder: '创建结束时间',
						changeFunc: function(value, self) {
							if (!value) {
								delete self.searchItem.create_time;
							} else {
								self.searchItem.create_time = ['between', value = value.map(function(e) {
									return e / 1000;
								})]
							};

						},
					},
					width: 200,
				},
				{
					label: '操作',
					listType: 'deal',
					width: 200
				},
			],
			// 按钮配置
			btn_info: [

				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						if (data) {
							return JSON.stringify(data.info) != '[]' ? '编辑信息' : '添加信息'
						} else {
							return ['编辑信息', '添加信息'];
						}
					},
					func: {
						apiName: function(self) {
							return JSON.stringify(self.formData.info) != "[]" ? "api_userInfoUpdate" :
								"api_userInfoAdd"
						},
						formData: function(self) {
							var data = self.formData.info;
							return data
						},
						postData: function(self) {
							if (self.btnName == '编辑信息') {
								var postData = {
									searchItem: {
										id: self.originFormData.info.id,
										user_no: self.originFormData.info.user_no
									},
									data: self.submitData
								}
							} else if (self.btnName == '添加信息') {
								var postData = {
									data: self.submitData
								};
							};
							postData.data.user_no = self.originFormData.user_no;
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '编辑账号'
					},
					func: {
						apiName: function(self) {
							return "api_userUpdate"
						},
						formData: function(self) {
							return self.formData
						},
						postData: function(self) {
							var postData = {
								searchItem: {
									id: self.formData.id,
									user_no: self.formData.user_no,
								},
								data: self.submitData
							}
							return postData;
						}
					},
				},
				{
					type: 'danger',
					icon: 'delete',
					size: 'mini',
					funcType: 'submit',
					position: 'header',
					text: function(data) {
						return '删除选中'
					},
					func: {
						apiName: function(self) {
							return "api_userUpdate"
						},
						postData: function(self) {
							var deleteArray = [];
							for (var i = 0; i < self.selectionArray.length; i++) {
								deleteArray.push(self.selectionArray[i].id);
							};
							var postData = {
								searchItem: {
									id: ['in', deleteArray],
									user_type: 0
								},
								data: {
									status: -1
								}
							};
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'header',
					text: function(data) {
						return '添加账号'
					},
					func: {
						apiName: function(self) {
							return "api_userAdd"
						},
						formData: function(self) {
							var data = {
								login_name: '',
								password: '',
							};
							return data
						},
						postData: function(self) {
							self.submitData.user_type = 0;
							var postData = {
								data: self.submitData
							};
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'normal',
					position: 'header',
					func: {
						func: function(self) {
							self.excelOutput(self);
						},
					},
					text: function(data) {
						return '导出'
					},
					funcType: 'func',
				},
			],


			searchItem: {
				user_type: 0
			},
			startSearchItem: {
				user_type: 0
			},
			optionData: {
				labelOptions: [],
				statusOptions: [{
						text: '启用',
						value: 1
					},
					{
						text: '禁用',
						value: -1
					},
				],
				roleOptions: [],
				typeOptions: [{
						text: '未申请',
						value: 0
					},
					{
						text: '审核中',
						value: 1
					},
					{
						text: '已通过',
						value: 2
					},
				],
			},
			otherData: {},
			UserInfo: {
				tableName: 'UserInfo',
				searchItem: {},
				key: 'user_no',
				middleKey: 'user_no',
				condition: 'in',
			},
			orderSearchItem:{pay_status:1,level:1}
		}

	},

	mounted() {
		const self = this;
		self.searchData = self.$$cloneForm(self.searchItem);
		this.init()
	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},
	watch: {
		$route(to, from) {
			console.log(to)
			this.init()
		},
		token() {

		}
	},
	methods: {

		/**
		 * 初始化
		 */
		init() {
			this.initMainData();
			this.initRoleData();
		},
		
		async excelOutput(self) {
		
			if (self.btnName == '导出') {
				const postData = {};
				postData.token = self.$store.getters.getToken;
				if (self.searchItem) {
					postData.searchItem = self.$$cloneForm(self.searchItem)
				};
				postData.excelOutput = {
					expTitle: 'test',
					expCellName: [
						
						
						
						{
							title: '姓名',
							key: ['info','name'],
							type: 'string',
						},
						{
							title: '地址',
							key: ['info','address'],
							type: 'string',
						},
						{
							title: '电话',
							key: ['info','phone'],
							type: 'string',
						},
						{
							title: '性别(1：男 2：女)',
							key: ['info','gender'],
							type: 'string',
						},
						{
							title: '年龄',
							key: ['info','age'],
							type: 'string',
						},
						{
							title: '购物次数',
							key: ['order','count'],
							type: 'string',
						},
						{
							title: '消费金额',
							key: ['order','price'],
							type: 'string',
						},
						{
							title: '消费时间跨度',
							key: ['orderDay'],
							type: 'string',
						},
					],
					fileName: '用户列表'
				};
		
				window.open('http://42.193.100.244/155/public/index.php/api/v1/Base/User/get?token=' +
					postData.token +
					'&searchItem=' +
					JSON.stringify(postData.searchItem) +
					'&excelOutput=' +
					JSON.stringify(postData.excelOutput))
			}
		},

		async initRoleData() {

			const self = this;
			const postData = {};

			postData.token = self.$store.getters.getToken;
			postData.searchItem = {
				status: 1
			};
			var res = await self.$$api_roleGet({
				data: postData
			});
			self.optionData.roleOptions = res.info.data;

		},

		/**
		 * 列表主函数
		 */
		async initMainData() {

			const self = this;
			const postData = {};
			postData.paginate = self.$$cloneForm(self.paginate);
			postData.token = self.$store.getters.getToken;
			if (self.searchItem) {
				postData.searchItem = self.$$cloneForm(self.searchItem)
			};
			if (JSON.stringify(self.getBefore) != "{}") {
				postData.getBefore = self.$$cloneForm(self.getBefore);
			};
			
			var res = await self.$$api_userGet({
				data: postData
			});

			self.mainData = res.info.data;
			self.paginate.count = res.info.total;

		},

	},


}



// WEBPACK FOOTER //
// ./src/views/user/user.js